import { useSearchParams } from 'react-router-dom';
import {
  MetricTableType,
  useMetricsTableV2Api,
} from '@data/hooks/api/use-metrics-table-v2-api/use-metrics-table-v2-api';
import { useTeacherMetricsArgs } from '@data/hooks/use-report-tables/use-teacher-metrics-args/use-teacher-metrics-args';

/** Every skill on one page: the skills table has no pagination. */
const PAGE_SIZE = 3000;

/** Every skill group and skill for the one student on the URL. */
export function useStudentSkills({ enabled = true } = {}) {
  const { args, ready } = useTeacherMetricsArgs();
  const [searchParams] = useSearchParams();
  const studentId = searchParams.get('studentId') ?? '';
  return useMetricsTableV2Api({
    ...args,
    // The service takes the one student as `studentId`, not as a filter.
    studentIds: null,
    studentId,
    metricType: MetricTableType.IndividualStudentSkills,
    page: 1,
    pageSize: PAGE_SIZE,
    orderBy: [{ key: 'SCORE', order: 'ASC' }],
    enabled: enabled && ready && !!studentId,
  });
}
